// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Xk-z","tupacHeader":"Yk-z","tupacHeader2":"Zk-z","tupacMenu":"_k-z","tupacMenu2":"al-z","tupacMain":"bl-z","tupacMain2":"cl-z"};